export const APA_VERSION_REQUEST = 'APA_VERSION_REQUEST';
export const APA_VERSION_SUCCESS = 'APA_VERSION_SUCCESS';
export const APA_VERSION_FAIL    = 'APA_VERSION_FAIL';

